export enum HsaGaleImportStatus {
  Running = "running",
  Completed = "completed",
  Failed = "failed",
}
